import React from 'react'
import { Mail, MapPin, Linkedin, type LucideIcon } from 'lucide-react'
import styles from './ContactInfoItem.module.scss'

type IconName = 'mail' | 'location' | 'linkedin'

interface ContactInfoItemProps {
  icon: IconName
  label: string
  value: string
  href?: string
}

const iconComponents: Record<IconName, LucideIcon> = {
  mail: Mail, location: MapPin, linkedin: Linkedin,
}

export const ContactInfoItem: React.FC<ContactInfoItemProps> = ({ icon, label, value, href }) => {
  const Icon = iconComponents[icon]

  return (
    <div className={styles.item}>
      <div className={styles.icon}>
        <Icon size={20} />
      </div>
      <div className={styles.content}>
        <span className={styles.label}>{label}</span>
        {href ? (
          <a
            href={href}
            target={href.startsWith('http') ? '_blank' : undefined}
            rel={href.startsWith('http') ? 'noopener noreferrer' : undefined}
            className={styles.valueLink}
          >
            {value}
          </a>
        ) : (
          <span className={styles.value}>{value}</span>
        )}
      </div>
    </div>
  )
}
